import { gql } from "graphql-tag";

export const getAllSavedLocations = gql`
  query getAllSavedLocations {
    getAllSavedLocations {
      results {
        id
        userId
        location
        lat
        lng
        locationType
        locationName
      }
      status
      errorMessage
    }
  }`;

export const addSavedLocations = gql`
  mutation addSavedLocations($id: Int, $location: String!, $lat: Float!, $lng: Float!, $locationType: String!, $locationName: String) {
    addSavedLocations(id: $id, location: $location, lat: $lat, lng: $lng, locationType: $locationType, locationName: $locationName) {
      id
      status
      errorMessage
    }
  }`;

export const removeSavedLocations = gql`
  mutation removeSavedLocations($id: Int) {
    removeSavedLocations(id: $id) {
      status
      errorMessage
    }
  }`;
